export const defaultComparisonConfig = () => {
    return {
        key: 'comparison',
        activeClass: 'border-bg-highlight',
        onAdd: function($self) {
            const position = $self.offset();
            const msg = __('add_to_comparison_msg');
            const $messageBox = $('#headerMessagesBox');
            const $ciMessage = $('.ci-message');

            window.initCiMessage($ciMessage, $messageBox).then(() => {
                window.$ciMessage.displayMessage(msg, 'body', {position: 'absolute', top: (position.top + ($self.outerHeight() / 2)) + 'px', left: position.left + 'px'});
                window.$ciMessage.displayMessage(msg, $messageBox, {position: 'absolute', top: '0px', left: '0px'});
            });

            ICube.data.set('comparisonChanged', true);
        },
        onRemove: function() {
            ICube.data.set('comparisonChanged', true);
        }
    }
}